export default __webpack_public_path__ + "static/media/ascension_training_platform_logo.bbe98017.svg";